import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'

export const SlippageToleranceTooltip = () => {
  const { t } = useTranslation()

  return (
    <TooltipBase>
      {t(
        'Setting a high slippage tolerance can help transactions succeed, but you may not get such a good price. Use with caution.',
      )}
    </TooltipBase>
  )
}
